module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("April 2005")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the first leg of the trip, in the passenger cabin of the long-bed shuttle, Patricia Vasquez had watched the Earth's cloud-smeared limb on a video monitor. Before her own transfer, cameras mounted in the shuttle bay had shown her the long waldos maneuvering the huge cargo out of the bay into the waiting arms of the OTV—orbital transfer vehicle—as if two spiders were trading a cocoon-wrapped fly. The operation had taken an hour, and with its slow fascination had distracted her from thoughts about her present circumstances.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When her own turn came and she donned the passenger bubble to be guided across the ten meters to the OTV's lock, she worked hard to appear calm. The bubble was made of transparent plastic, so she did not suffer from claustrophobia—almost the opposite, in fact. She could feel the immensity of the blackness beyond the spacecraft, though she could not make out stars. They were outdone by the glow of the Earth and the close, brightly lighted surfaces of the OTV, a train of clustered tanks, balls and prisms wrapped in aluminum beams.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The three-man, two-woman crew of the OTV greeted her warmly in the narrow tunnel as she \"hatched,\" then guided her to a seat just behind theirs. From that vantage, she had a clear, direct view, and now she could see the steady pinpoints of stars.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("So confronted, with none of the comfortable separation of a video monitor frame, space seemed to extend into a mating of infinite, star-cluttered halls. She felt as if she could walk down any one of the halls and become lost in altered perspective.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She still wore the black jumpsuit she had been handed in Florida just six hours before. She felt dirty. Her hair, even though tied up in a bun, let loose irritating wisps. She could smell her own nervousness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The crew floated around her, making last-minute checks, punching readings into slates and processors. Patricia examined their colored suits—the women in red and blue, the men in green and black and gray—and idly wondered how they were ranked and who commanded. Everything seemed casually efficient with no deference in voice or manner, as if they were civilians. But they were not.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The OTV was a registered unarmed military vehicle, subject to the restrictions imposed after the Little Death. It was one of dozens of new vehicles that had been constructed in Earth orbit since the appearance of the Stone, and it differed substantially from the vehicles that had serviced the Joint Space Force's Orbital Defense Platforms. It was larger and capable of traveling much greater distances; by treaty, it could not carry cargoes to the ODPs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We're leaving in three minutes,\" said the shuttle's copilot, a blond woman whose name Patricia had already forgotten. She touched Patricia on the shoulder and smiled. \"Everything will be hectic for a half hour or so. If you need a drink or have to use the lavatory, now's the time.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Patricia shook her head and returned the smile. \"I'm fine.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good. Virgin?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Patricia stared.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"First flight, she means,\" the other woman clarified. Patricia remembered her name—Rita, just like her mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of course,\" Patricia said. \"Would I be sitting here acting like a cow in a slaughterhouse, otherwise?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The blond laughed. The pilot—James or Jack, with beautiful green eyes—looked over his shoulder at her, his head framed by the belt and sword of Orion. \"Relax, Patricia,\" he said. So calm. She was almost intimidated by their professional assurance. They were spacefarers, originally assigned to the near-Earth orbit platforms and now working the distances between Earth, Moon and Stone. She was just a young woman fresh out of graduate school, and she had never in her life even left the state of California until traveling to Florida for the shuttle flight from Kennedy Space Center.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She wondered what her father and mother were doing now, sitting at home in Santa Barbara. Where did they imagine their daughter to be? She had said good-bye just a week ago. Her stomach still churned at the memory of her last few moments with Paul. His letters would get to her, that was guaranteed—forwarded through the APO address. But what could she tell him in her return messages? Very likely, nothing. And her time in space had been estimated at two months, minimum.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She listened to the rumble and purr of the OTV machinery. She heard fuel pumps, mystery noises, gurgles like large water bubbles popping behind the passenger cabin, then the sharp tings of the attitude motors driving the craft away from the shuttle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They began rotating, their axis somewhere near the middle of the cocoon cargo, clamped where a spare hexagonal fuel tank would have otherwise been. The OTV lurched forward with the impulse of its first engine burn. The blond, still not in her seat, landed on her feet against the rear bulkhead, flexed her knees with the impact and finished her sequence on the processor.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then everyone buckled in.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The second burn took place fifteen minutes later. Patricia closed her eyes, nestled into the couch and resumed work on a problem she had put aside more than two weeks before. She had never required paper during the initial stages of her work. Now, the Fraktur symbols paraded before her, separated by her own brand of sign notation, invented when she was ten years old. There was no music—she usually listened to Vivaldi or Mozart while working—but nevertheless, she became immersed in a sea of abstraction. Her hand went to the pack of music coins and the slate stereo attachment in her small effects bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A few minutes later, she opened her eyes. Everyone was in their seats, staring intently at instrument panels. She tried to nap. Briefly, before dozing off, she ran through her Big Question again:")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Why had she, in particular, been chosen from a list of mathematicians that must have been meters long? That she had won a Fields Award didn't seem reason enough; there were other mathematicians of far greater experience and stature. . ."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hoffman hadn't really offered an explanation. All she had said was, \"You're going to the Stone. All that you'll need to know is up there, and it's classified, so I'm not allowed to give you documents while you're here on Earth. You'll have a hell of a lot of studying to do. And I'm sure it will be glorious fun for a mind like yours.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As far as Patricia knew, her expertise had no practical use whatsoever, and she preferred it that way.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She didn't doubt her talents. But the very fact that they were calling on her—that they might need to know about (as she had expressed it in her doctoral dissertation, Non-gravity Bent Geodesics of n-Spatial Reference Frames: An Approach to Superspace Visualization and Probability Clustering)—made her even more apprehensive.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Six years ago, a Stanford math professor had told her that the only beings who would ever fully appreciate her work would be gods or extraterrestrials.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the dark, sleepily drifting away from the OTV noises and the sensation of her stomach pressing always upward, she thought of the Stone. The governments involved did not discourage speculation but provided no fuel to feed the fires. The Russians, allowed on the Stone only the last year, hinted darkly at what their researchers had seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Amateur astronomers—and a few civilian professionals who hadn't been visited by government agents—had pointed out the three regular latitudinal bands and the odd dimples at each pole, as if it had been turned on a lathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The upshot was, everyone knew it was big news, perhaps the biggest news of all time.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And so it wasn't incredible that Paul, putting a few odd facts together, had told her he thought she was going to the Stone. \"You're just too far-out a mind to be going anywhere else,\" he had said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Gods and extraterrestrials. Still, she managed to nap.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When she awoke, she saw the Stone briefly as the OTV swung around for its docking maneuver. It looked much like the pictures she had seen many times before published in newspapers and magazines—bean-shaped, about a third as wide in the middle as it was long, heavily cratered between the smoothly artificial excavated bands. Ninety-one kilometers in diameter at its widest, two hundred ninety-two kilometers long. Rock and nickel and iron and not nearly as simple as that.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Approaching south polar axis,\" the blond said, leaning around in her chair to look back at Vasquez. \"A little briefing, in case they haven't told you already. Blind leading the blind, honey.\" She glanced meaningfully at her shipmates. \"First, some facts and figures important to mere navigators. Note that the Stone is rotating on its long axis. That's nothing surprising—everyone knows that. But it's rotating once every seven minutes or so—\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Every six point eight two four minutes,\" James or Jack corrected.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That means,\" the blond continued, unfazed, \"that anything loose on the outer surface will fly away at a pretty good clip, so we can't dock there. We have to go through the pole.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There's stuff inside?\" Patricia asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Quite a lot of stuff, if they're keeping everything—and everyone—we've been bringing up in the past few years,\" James or Jack said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The Stone's albedo matches any of a number of siliceous asteroids. Apparently, that's what it was at one time. Here's the south pole now,\" Rita said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the middle of the large polar crater was an indentation—judging from the scale of the Stone itself, quite tiny, no more than a kilometer deep and three or four kilometers wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Stone's rotation was easily discernible. As the OTV matched course with the Stone, then began its approach along the axis, the crater enlarged and showed even more detail. With hardly any surprise at all, Patricia realized the floor was marked by shallow hexagons, like a beehive.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At the center of the indentation was a circular black spot about a hundred meters across. A hole. An entrance. It loomed larger and larger but lost none of its intense blackness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The OTV slid into the hole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We have to maintain our position about five minutes, until they bring the rotating dock up to speed,\" James or Jack said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We did all this?\" Patricia asked, her voice unsteady. \"In just five years?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, honey,\" the blond said. \"It was here already, I'm sure you've heard the Stone is hollow inside with seven chambers. We have a fair number of personnel and thousands of tons of equipment in there, doing God knows what and finding things we'd give our eyeteeth to see, believe me. But this is where our knowledge stops, and we've been instructed not to pass along rumor. You won't be needing it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We've been riding a docking signal for the last seven minutes,\" James or Jack said. \"Voice contact any second.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The radio chimed. \"OTV three-seven,\" a calm tenor male voice said. \"We have prime dock rotating. Advance at point one meters per second.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Rita flipped a switch and the OTV's floods came on, partially illuminating the inside of a gray cylinder that dwarfed the craft. Four rows of lights appeared ahead of them, wobbling back and forth slightly as the rotating dock adjusted its speed. \"Here we go.\" The OTV advanced slowly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Patricia nodded and held her hands tightly in her lap. The bump was hardly discernible as the OTV motors went ting all around and brought them to a stop inside the tunnel. A hatch opened ahead of the ship and three men in space suits floated into view, carrying cables. They used suit thrusters to fly around the OTV and tie it down.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You're hooked, OTV three-seven,\" the radio voice said a few minutes later. \"Welcome to the Stone.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thanks,\" James or Jack said. \"We have a big load in the hopper and precious cargo up front. Treat them gently.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Foreign or domestic?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Domestic. Best California vintage.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Patricia didn't know whether they were talking about a cargo of wine or her. She was too nervous to ask.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Got you clear.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Any more mysteries to leak to us, guide?\" the blond asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My people want the hopper cargo released in five minutes.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Timing on.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"More mysteries. Let's see. Why is a raven like a writing desk?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Bastard. I'll think on it,\" James or Jack said. He switched off the mike and floated up from his couch to help Patricia with her belts. \"Closemouthed, all of them,\" he said, guiding her to the lock access corridor. \"I leave you to their tender mercies. And promise us, someday—pretty please?—\" he patted her shoulder paternally \"—when all this is settled and we're reminiscing in a bar in Sausalito. . .” He grinned at her, knowing how ridiculous the image was. \"Tell us what the hell happened up here, step by step? We'll savor it the rest of our lives.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why do you think they'll tell me?\" Patricia asked. \"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why, don't you know?\" Rita joined them in the lock. \"You've been given top billing. You're going to save their collective hide.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Patricia climbed in to the transfer bubble and they closed the lock behind her. Watching through the lock port, she could see the curious hunger in their faces. The lock hatch swung open and two men in spacesuits reached in to pull the bubble from the OTV. She was passed along hand-to-hand through a circular opening in the dock's dark gray surface.")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba7ce16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 75
// module chunks = 0